import React from 'react';

export const TsuMoreInfoModal = {
  title: 'Additional Tsunami Event Information',
  body: (
    <div>
      <p>
        The link will display additional tsunami information. The information may include effects such as the numbers of injuries and houses destroyed, the tsunami magnitude and intensity, warning status, references and comments.
      </p>
    </div>
  ),
};
